import React from "react";
import Button from "../Components/Button";
import { BRAND } from "../config/brand";
import CosmicPyramidCanvas from "./CosmicPyramidCanvas";
import SectionThree from "./SectionThree";

function HeroSection() {
  return (
    <div className="hero-section">
      <CosmicPyramidCanvas
        className="hero-cosmic-canvas"
        focusX={0.292}
        focusY={0.47}
        isVisiblePramid={false}
        particleCount={150}
        visualScale={0.78}
      />
      <div className="hero-orbit hero-orbit-one" />
      <div className="hero-orbit hero-orbit-two" />
      <div className="hero-content">
        <h1>
          {BRAND.name}
          <br />
          watches the future of digital value.
          <br />
        </h1>
        <p className="hero-p">
          1EYE Chain is an AI powered Layer 1 blockchain designed to deliver scalable, secure, and intelligent decentralized infrastructure.
          It combines blockchain technology with AI powered features to support a growing ecosystem of decentralized applications and services.
        </p>
        <div className="hero-btns">
          {/* <Button text="Details" className="secondary" /> */}
          <a
            href={BRAND.whitepaperUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button text="Token Details" className="secondary" />
          </a>
          <a href={BRAND.whitepaperUrl} target="_blank" rel="noopener noreferrer">
            <Button text="Whitepaper" className="primary" />
          </a>
        </div>
        <div className="hero-metrics">
          <div>
            <strong>{BRAND.tokenSymbol}</strong>
            <small>Token Symbol</small>
          </div>
          <div>
            <strong>$1</strong>
            <small>Stable Entry</small>
          </div>
          <div>
            <strong>BSC</strong>
            <small>Network</small>
          </div>
        </div>
      </div>
      <div className="hero-img">
        <SectionThree cardOnly />
      </div>
    </div>
  );
}

export default HeroSection;
